//#region ../erd-editor-schema/dist/v3/schema/relationship.entity.js
var RelationshipType = {
	ZeroOne: 2,
	ZeroN: 4,
	OneOnly: 8,
	OneN: 16
};
var RelationshipTypeList = Object.values(RelationshipType);
var StartRelationshipType = {
	ring: 1,
	dash: 2
};
var StartRelationshipTypeList = Object.values(StartRelationshipType);
var ReferentialAction = {
	none: 1,
	noAction: 2,
	cascade: 4,
	setNull: 8,
	setDefault: 16,
	restrict: 32
};
var ReferentialActionList = Object.values(ReferentialAction);
var Direction = {
	left: 1,
	right: 2,
	top: 4,
	bottom: 8
};
var DirectionList = Object.values(Direction);
//#endregion
export { Direction, DirectionList, ReferentialAction, ReferentialActionList, RelationshipType, RelationshipTypeList, StartRelationshipType, StartRelationshipTypeList };
